import React from 'react';
import ReactDOM from 'react-dom';
import { mergeStyles } from '@fluentui/react';

import App from './App';
import './index.css';
import './styles/utilities.css';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import reportWebVitals from './reportWebVitals';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';

// Inject some global styles
mergeStyles({
  ':global(body,html,#root)': {
    margin: 0,
    padding: 0,
    height: '100vh',
  },
});

if (process.env.REACT_APP_ENV === 'production') {
  const {
    REACT_APP_AWS_RUM_IDENTITY_POOL_ID,
    REACT_APP_AWS_RUM_ENDPOINT,
    REACT_APP_AWS_RUM_APPLICATION_ID,
    REACT_APP_AWS_RUM_APPLICATION_VERSION,
    REACT_APP_AWS_RUM_APPLICATION_REGION,
  } = process.env;

  if (
    !REACT_APP_AWS_RUM_IDENTITY_POOL_ID ||
    !REACT_APP_AWS_RUM_ENDPOINT ||
    !REACT_APP_AWS_RUM_APPLICATION_ID ||
    !REACT_APP_AWS_RUM_APPLICATION_VERSION ||
    !REACT_APP_AWS_RUM_APPLICATION_REGION
  ) {
    console.error('AWS RUM no está configurado correctamente');
  } else {
    try {
      const config: AwsRumConfig = {
        sessionSampleRate: 1,
        identityPoolId: REACT_APP_AWS_RUM_IDENTITY_POOL_ID,
        endpoint: REACT_APP_AWS_RUM_ENDPOINT,
        telemetries: ['performance', 'errors', 'http', 'interaction'],
        allowCookies: true,
        enableXRay: false,
        signing: true,
      };

      const awsRumInstance = new AwsRum(
        REACT_APP_AWS_RUM_APPLICATION_ID,
        REACT_APP_AWS_RUM_APPLICATION_VERSION,
        REACT_APP_AWS_RUM_APPLICATION_REGION,
        config,
      );

      // Hacer AWS RUM disponible globalmente para nuestro XhrRequestHandler
      (window as any).awsRum = awsRumInstance;

      console.log('AWS RUM inicializado correctamente con eventos personalizados habilitados');
    } catch (error) {
      console.error('Error al inicializar AWS RUM:', error);
    }
  }
}

function renderApp(newVersion: boolean, onUpdate: () => void) {
  ReactDOM.render(<App newVersionAvailable={newVersion} onUpdateVersion={onUpdate} />, document.getElementById('root'));
}

renderApp(false, () => {});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Recargar solo cuando el nuevo service worker realmente tomó el control
// (en vez de adivinar con un setTimeout, que corre la carrera de recargar
// antes de que la activación termine y seguir sirviendo la version vieja).
let refreshingAfterUpdate = false;
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.addEventListener('controllerchange', () => {
    if (refreshingAfterUpdate) return;
    refreshingAfterUpdate = true;

    const currentUrl = new URL(window.location.href);
    currentUrl.searchParams.set('_t', Date.now().toString());
    window.location.replace(currentUrl.toString());
  });
}

const configuration = {
  onUpdate: (registration) => {
    if (registration && registration.waiting) {
      renderApp(true, () => {
        registration.waiting.postMessage({ type: 'SKIP_WAITING' });
      });
    }
  },
};

// serviceWorkerRegistration.unregister();
serviceWorkerRegistration.register(configuration);
